import React, { memo, useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'antd'
import { inject, observer } from 'mobx-react'

import UserDetail from '../Contacts/ListDepartment/UserDetail'
import { ContactDetailModalStyle } from '../Contacts/ListDepartment/ListDepartmentStyled'

const UserOverview = userOverviewProps => {
  const {
    handleCancelViewUser,
    isVisibleUser,
    userStore,
  } = userOverviewProps

  const selectedUser = userOverviewProps.selectedUser || userStore?.selectedUser

  useEffect(() => {
    if (!isVisibleUser || !selectedUser) return

    userStore?.clearAvatarByUserCode?.()

    if (selectedUser?.code) {
      userStore?.getAvatarByUserCode?.(selectedUser.code)?.catch(() => undefined)
    }
  }, [isVisibleUser, selectedUser, userStore])

  const closeAndResetForm = useCallback(() => {
    userStore?.clearAvatarByUserCode?.()
    handleCancelViewUser()
  }, [handleCancelViewUser, userStore])

  return (
    <>
      <ContactDetailModalStyle />
      <Modal
        className="contact-detail-modal"
        wrapClassName="contact-detail-modal"
        title="Thông tin nhân viên"
        visible={isVisibleUser}
        footer={null}
        width={650}
        destroyOnClose
        onCancel={closeAndResetForm}>
        <UserDetail selectedUser={selectedUser} />
      </Modal>
    </>
  )
}

UserOverview.propTypes = {
  handleCancelViewUser: PropTypes.func,
  isVisibleUser: PropTypes.bool,
  selectedUser: PropTypes.object,
  userStore: PropTypes.object,
}

export default memo(
  inject(
    'commonStore',
    'loadingAnimationStore',
    'userStore'
  )(observer(UserOverview))
)
